<template>
  <a
    href="https://apps.apple.com/app/id6758197969"
    target="_blank"
    rel="noopener noreferrer"
    class="btn"
  >
    <span class="btn__text">Download the App</span>
  </a>
</template>
